import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Loader, Dropdown, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {providerOrderTypes, transportTypes} from '../../../common/dictionaries/classification';
import {parseProviders} from '../../../common/util/options';
import DaysSection from './daysSection';
import SendButton from './sendButton';
import './orderTracking.scss';

class OrderTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {'provider': '', 'orderType': 'NORMAL'};
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleProviderChange = this.handleProviderChange.bind(this);
    this.handleOrderTypeChange = this.handleOrderTypeChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Providers,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }

    this.props.restoreProviderOrderTrackingConfig();
    this.props.loadProviders({'withOrigin': true});
  }

  handleBackClick() {
    this.props.navigateBack();
  }

  handleProviderChange(event, data) {
    this.props.getProviderOrderTrackingConfig(data.value, this.state.orderType);
    this.setState({'provider': data.value});
  }

  handleOrderTypeChange(event, data) {
    this.props.getProviderOrderTrackingConfig(this.state.provider, data.value);
    this.setState({'orderType': data.value});
  }

  renderConfiguration() {
    if (this.props.loading) {
      return (
        <Card raised fluid>
          <Loader active inline='centered' />
        </Card>
      );
    }

    return (
      <Card.Group itemsPerRow={2} className='tracking-config-values'>
        {this.renderSections()}
      </Card.Group>
    );
  }

  renderSections() {
    return transportTypes.map((type, index) => {
      return <DaysSection transport={type.text} section={type.secondValue} key={index} />;
    });
  }

  render() {
    const {loading, loadingProviders, providers} = this.props;

    return (
      <div className='provider-orders-tracking-config'>
        <Card raised fluid className='tracking-config-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='12' textAlign='left'>
                <h2>
                  <Icon
                    link
                    color='black'
                    className='arrow left'
                    onClick={this.handleBackClick}
                  />
                  Configuración de Parámetros Tracking - Pedidos Concesionarios
                </h2>
              </Grid.Column>
              <Grid.Column width='4' textAlign='right'>
                <Button
                  secondary
                  content='CANCELAR'
                  onClick={this.handleBackClick}
                />
                <SendButton disabled={!this.state.provider} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='5' textAlign='left'>
                <Dropdown
                  selection
                  fluid
                  search
                  name='provider'
                  placeholder='Proveedor'
                  loading={loadingProviders}
                  disabled={loadingProviders || loading}
                  options={parseProviders(providers)}
                  value={this.state.provider}
                  onChange={this.handleProviderChange}
                />
              </Grid.Column>
              <Grid.Column width='3' textAlign='center' verticalAlign='middle'>
                <Dropdown
                  selection
                  fluid
                  name='orderType'
                  placeholder='Tipo de Pedido'
                  disabled={loading}
                  options={providerOrderTypes}
                  value={this.state.orderType}
                  onChange={this.handleOrderTypeChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        {this.renderConfiguration()}
      </div>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    'permissions': state.session.permissions,
    'loadingProviders': state.provider.loading,
    'loading': state.providerOrderTrackingConfig.loading,
    'providers': state.provider.list,
  };
};

const {
  loadProviders,
  getProviderOrderTrackingConfig,
  restoreProviderOrderTrackingConfig,
  navigateTo,
  navigateBack,
} = Actions;

export default connect(mapStateToProp, {
  loadProviders,
  getProviderOrderTrackingConfig,
  restoreProviderOrderTrackingConfig,
  navigateTo,
  navigateBack,
})(OrderTracking);
